/**
 * Picking-totes helpers (client-side mirror of `companyUsesTotes` in @monrepo-build/db).
 *
 * DEFAULT-ON / FAIL-OPEN: only an explicit `false` turns totes off. `undefined` — from a stale
 * bundle whose query predates the field, or from a selection set that omits it — means "totes work
 * exactly as they always have", which is the only safe guess on a handheld mid-shift.
 *
 * TWO SOURCES, ON PURPOSE:
 *  - the ROOT STORE copy (initialRenderData.connectedCompanies) is fetched once at app start and
 *    may be a whole shift stale. Use it ONLY for cosmetics — the list sub-label, the search clause.
 *  - the PER-PAGE copy (`company(id:$vendorId){ id usesTotes }` inside a screen's own network-only
 *    document, mirroring SalesOrderShipping.data.tsx) is re-read on every screen open. Use it for
 *    anything that can BLOCK a picker: the Complete gate, the Add Tote CTA, the /add-tote guard.
 *    Note it is still a SECONDARY read server-side (getCompanyById uses readPreference:'secondary'),
 *    so a just-flipped value can lag by replication — always in the safe direction.
 *
 * The server is authoritative — toteAssign 403s when totes are off — so a stale ON value costs the
 * picker one legible error, not a corrupted order.
 */
export const companyUsesTotes = (
  company: { usesTotes?: boolean | null } | null | undefined,
): boolean => company?.usesTotes !== false;
